var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"121fc007e46a7b1b6c78e91731f3935f47e9e1a4"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["website@coach-mate"]={id:"121fc007e46a7b1b6c78e91731f3935f47e9e1a4"};
      